<template>
	<div class="text-primary font-thin sm:whitespace-pre-line flex flex-col gap-4 pageSubtitleComponent">
		<slot></slot>
	</div>
</template>

<script setup></script>

<style scoped></style>
